const styles = {
  container: {
    height: '600px',
  }
}

export default styles
